import React from 'react';

const SvgSuccessReceiveOffer = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 300 300"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "tourlane-EnquiryExperience-SuccessReceiveOffer__path-1",
  d: "M18.615.484l218.718 30.681-18.231 129.48a4.441 4.441 0 01-5.01 3.776L4.254 134.279a4.43 4.43 0 01-3.796-4.832l.02-.173c0-.001 0-.002.003-.002L18.615.484z"
}), /*#__PURE__*/React.createElement("path", {
  id: "tourlane-EnquiryExperience-SuccessReceiveOffer__path-3",
  d: "M27 27.802C38.076 8.597 65.53-.564 109.364.319c.722.015 1.44.117 2.137.306l1.04.285c16.243 4.502 30.04 10.933 41.39 19.292 11.835 8.716 34.446 32.348 67.832 70.895L116.58 168.826a8.868 8.868 0 01-10.543 0L1.155 91.292l-.25-.119.015-.055-.017-.011.02-.001C7.153 68.247 15.845 47.145 27 27.802z"
}), /*#__PURE__*/React.createElement("path", {
  id: "tourlane-EnquiryExperience-SuccessReceiveOffer__path-5",
  d: "M105.223 13.096a8.868 8.868 0 0110.573-.04l104.537 76.987 2.95-.01-106.705 78.798a8.868 8.868 0 01-10.537 0L.339 90.757l1.128-.005z"
}), /*#__PURE__*/React.createElement("path", {
  id: "tourlane-EnquiryExperience-SuccessReceiveOffer__path-8",
  d: "M9.067 11.578c-.471 14.998-.471 24.996 0 29.995.407 4.323 1.167 10.354 2.278 18.093a5.312 5.312 0 004.265 4.463l3.469.66c-1.4 7.784-2.977 13.324-4.731 16.618-1.754 3.295-4.089 5.102-7.003 5.422C1.53 97.713-.832 104.239.258 106.405c1.091 2.166 6.809 4.385 17.153 6.658 31.353-4.308 47.029-6.792 47.029-7.454 0-.661-3.33-6.643-9.992-17.946l-1.028-2.341a34.356 34.356 0 01-2.672-17.76 71.908 71.908 0 014.454-17.91l.51-1.305 4.646-17.137-5.91-5.18C52.492 14.159 50.902 7.787 49.68 6.913c-1.835-1.31-15.837-4.217-17.893-5.361C30.415.789 23.246.272 10.28 0L9.067 11.578z"
}), /*#__PURE__*/React.createElement("path", {
  id: "tourlane-EnquiryExperience-SuccessReceiveOffer__path-11",
  d: "M0 75.145l13.92-49.037A29.479 29.479 0 0126.666 9.15l3.118-1.946a50.693 50.693 0 0113.964-6.028L48.23 0l-.897 4.788C45.968 12.07 50.767 19.08 58.05 20.445c.245.045.492.084.739.117a24.26 24.26 0 0022.56-9.533L89.594 0l15.79 8.33a51.66 51.66 0 0113.963 10.766 32.468 32.468 0 017.867 15.353l8.447 40.696H0z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "tourlane-EnquiryExperience-SuccessReceiveOffer__linearGradient-10",
  x1: "57.853%",
  x2: "57.853%",
  y1: "58.039%",
  y2: "97.31%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#59DD7D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#50C871"
})), /*#__PURE__*/React.createElement("filter", {
  id: "tourlane-EnquiryExperience-SuccessReceiveOffer__filter-7",
  width: "107.2%",
  height: "110%",
  x: "-3.6%",
  y: "-5%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  result: "shadowBlurInner1",
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -8,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowInnerInner1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
}))), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "scale(-1 1) rotate(-8 942.05 2277.907)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-EnquiryExperience-SuccessReceiveOffer__mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-EnquiryExperience-SuccessReceiveOffer__path-1"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#F7F7F7",
  xlinkHref: "#tourlane-EnquiryExperience-SuccessReceiveOffer__path-1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EBF0FD",
  d: "M8.116 85.745l93.674 80.324a8.868 8.868 0 009.263 1.42L226.664 118 8.116 85.745z",
  mask: "url(#tourlane-EnquiryExperience-SuccessReceiveOffer__mask-2)",
  transform: "scale(1 -1) rotate(-17 -732.22 0)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDEFF0",
  d: "M8.116 85.745l93.674 80.324a8.868 8.868 0 009.263 1.42L226.664 118 8.116 85.745z",
  mask: "url(#tourlane-EnquiryExperience-SuccessReceiveOffer__mask-2)",
  transform: "scale(1 -1) rotate(-17 -732.22 0)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59DD7D",
  d: "M10.282 28.852l15.293 2.112-5.143 9.988L5.31 38.874z",
  mask: "url(#tourlane-EnquiryExperience-SuccessReceiveOffer__mask-2)",
  transform: "rotate(91.4 15.443 34.902)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F4144",
  d: "M4.45 60.566L.941 71.173l15.267-.016 3.683-10.595",
  mask: "url(#tourlane-EnquiryExperience-SuccessReceiveOffer__mask-2)",
  transform: "rotate(99.4 10.417 65.867)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F4144",
  d: "M12.737-1.162L9.229 9.444l15.267-.015L28.18-1.167",
  mask: "url(#tourlane-EnquiryExperience-SuccessReceiveOffer__mask-2)",
  transform: "rotate(99.4 18.704 4.139)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#59DD7D",
  d: "M-.56 91.532l-3.508 10.606 15.268-.016 3.683-10.595",
  mask: "url(#tourlane-EnquiryExperience-SuccessReceiveOffer__mask-2)",
  transform: "rotate(99.4 5.408 96.833)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F4144",
  d: "M-4.821 122.602L-8.33 133.21l15.267-.016 3.683-10.595",
  mask: "url(#tourlane-EnquiryExperience-SuccessReceiveOffer__mask-2)",
  transform: "rotate(99.4 1.146 127.903)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 290.251 60)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C8CCCF",
  d: "M105.223 13.096a8.868 8.868 0 0110.573-.04l105.967 78.041-104.72 77.053a8.868 8.868 0 01-10.481.022L1.164 91.298l-.26-.124.045-.034-.046-.032.091-.001z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-EnquiryExperience-SuccessReceiveOffer__mask-4",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-EnquiryExperience-SuccessReceiveOffer__path-3"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#tourlane-EnquiryExperience-SuccessReceiveOffer__mask-4)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(33.845 32.761)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M2.846 0h148.326a2.846 2.846 0 012.845 2.826l.96 136.238a2.846 2.846 0 01-2.846 2.866H2.846A2.846 2.846 0 010 139.084V2.846A2.846 2.846 0 012.846 0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 49,
  height: 13.3,
  x: 52.5,
  y: 100.1,
  fill: "#59DD7D",
  rx: 1.4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C8CCCF",
  d: "M59.885 75.95h33.53a.735.735 0 110 1.47h-33.53a.735.735 0 110-1.47zM52.185 84.14h48.93a.735.735 0 110 1.47h-48.93a.735.735 0 110-1.47z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3F4144",
  fillRule: "nonzero",
  d: "M77 23.1c10.438 0 18.9 8.462 18.9 18.9 0 10.438-8.462 18.9-18.9 18.9-10.438 0-18.9-8.462-18.9-18.9 0-10.438 8.462-18.9 18.9-18.9zm9.208 7.754c-.399.33-1.46.695-1.991.695H69.85c-.531 0-1.626-.364-2.058-.695v5.925h.664c.83 0 1.028-.165 1.128-.96l.066-.496c.166-1.457 1.228-2.218 3.153-2.218h1.625V50.65c.033.695-.132.993-.763 1.225l-.564.1c-.465.066-.664.363-.664 1.092v.563h9.225v-.563c0-.729-.166-1.026-.697-1.093l-.597-.1c-.531-.099-.797-.529-.797-1.224V33.105h1.295c2.389-.034 3.218.497 3.583 2.218l.067.497c.099.695.331.96.895.96h.797z"
})))), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#tourlane-EnquiryExperience-SuccessReceiveOffer__filter-7)",
  transform: "matrix(-1 0 0 1 290.251 60)",
  xlinkHref: "#tourlane-EnquiryExperience-SuccessReceiveOffer__path-5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EDEFF0",
  d: "M194.798 228.747l-12.332-7.412a8.871 8.871 0 00-9.372.21l-18.22 12.02 18.714 11.372 21.21-16.19z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#C8CCCF",
  strokeLinecap: "round",
  strokeWidth: 1.05,
  d: "M0 285.084l300.182.855"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "scale(-1 1) rotate(-3 2344.262 2255.882)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-EnquiryExperience-SuccessReceiveOffer__mask-9",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-EnquiryExperience-SuccessReceiveOffer__path-8"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#EDEFF0",
  xlinkHref: "#tourlane-EnquiryExperience-SuccessReceiveOffer__path-8"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D2D7DA",
  d: "M17.151 64.382c4.84.803 9.131 1.071 12.876.803 5.618-.401-7.803 7.332-14.635 5.222",
  mask: "url(#tourlane-EnquiryExperience-SuccessReceiveOffer__mask-9)",
  transform: "rotate(-1 23.38 67.577)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#3F4144",
  d: "M78.77 113.584c6.42-3.054 12.123-.581 17.109 7.418 8.069.023 13.13 2.481 15.181 7.375 2.052 4.895.76 9.724-3.878 14.489.103 2.523-.033 4.594-.407 6.213-.373 1.618-1.093 3.5-2.159 5.643-.074-4.745-.304-8.28-.691-10.607-.387-2.326-1.318-5.006-2.794-8.04-3.994 1.082-9.223 1.266-15.686.551-9.696-1.072-16.641 2.68-18.294 6.692-1.653 4.012 2.404 7.07-.301 11.81-1.804 3.159-4.55 4.75-8.24 4.775 1.141 4.401 1.657 7.928 1.55 10.58-.108 2.653-.392 5.774-.853 9.363-5.787-4.493-9.668-9.16-11.644-14.001-1.975-4.841-3.025-9.035-3.149-12.581-3.138-2.278-4.587-5.702-4.347-10.273.24-4.57 1.966-7.787 5.177-9.65.292-7.23 2.794-12.644 7.507-16.239 7.07-5.392 16.289 1.062 25.92-3.518z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 146.02 209.939)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-EnquiryExperience-SuccessReceiveOffer__mask-12",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-EnquiryExperience-SuccessReceiveOffer__path-11"
})), /*#__PURE__*/React.createElement("use", {
  fill: "url(#tourlane-EnquiryExperience-SuccessReceiveOffer__linearGradient-10)",
  xlinkHref: "#tourlane-EnquiryExperience-SuccessReceiveOffer__path-11"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4BC36C",
  d: "M23.645 78.125l8.384-18.358-2.98 18.358",
  mask: "url(#tourlane-EnquiryExperience-SuccessReceiveOffer__mask-12)",
  transform: "rotate(-9 27.837 68.946)"
}))))));

export default SvgSuccessReceiveOffer;